import { useRouter } from '@townsquare/router/useRouter';

import { matchRoute } from '@townsquare/router/primitives/match-route';
import { teamsSettingsRoute } from '@townsquare/routes/teams-settings-view';

export const useIsSettingsRoute = () => {
	const [routerStore] = useRouter();
	return Boolean(matchRoute([teamsSettingsRoute], routerStore.location.pathname, undefined));
};
